var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "pa-4", attrs: { flat: "" } },
    [
      _c(
        "div",
        { staticClass: "text-subtitle-2 mb-2" },
        [
          _c("v-icon", { staticClass: "mr-1", attrs: { small: "" } }, [
            _vm._v("mdi-account-group"),
          ]),
          _vm._v(" Capacidades "),
        ],
        1
      ),
      _c("div", { staticClass: "text-caption grey--text mb-4" }, [
        _vm._v(
          " Defina as capacidades e selecione qual está ativa para o cálculo atual. "
        ),
      ]),
      _c(
        "v-row",
        { attrs: { align: "stretch" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "4" } },
            [
              _c(
                "v-card",
                {
                  class: [
                    "capacity-card",
                    { "capacity-card--active": _vm.capacityMode === "RED" },
                  ],
                  attrs: { outlined: "" },
                  on: {
                    click: function ($event) {
                      return _vm.selectMode("RED")
                    },
                  },
                },
                [
                  _c(
                    "v-card-text",
                    { staticClass: "text-center pa-3" },
                    [
                      _c(
                        "v-radio-group",
                        {
                          staticClass: "mt-0 mb-2",
                          attrs: {
                            value: _vm.capacityMode,
                            "hide-details": "",
                          },
                          on: { change: _vm.selectMode },
                        },
                        [
                          _c("v-radio", {
                            staticClass: "justify-center",
                            attrs: { value: "RED" },
                            scopedSlots: _vm._u([
                              {
                                key: "label",
                                fn: function () {
                                  return [
                                    _c(
                                      "span",
                                      { staticClass: "text-subtitle-2" },
                                      [_vm._v("Reduzida")]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "active-slot mb-2" },
                        [
                          _c(
                            "v-chip",
                            {
                              class: {
                                "active-slot__chip--hidden":
                                  _vm.capacityMode !== "RED",
                              },
                              attrs: { "x-small": "", color: "primary" },
                            },
                            [_vm._v(" Ativo ")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "capacity-desc text-caption grey--text mb-2",
                        },
                        [_vm._v(" Capacidade mínima ")]
                      ),
                      _c("v-text-field", {
                        staticClass: "centered-input",
                        attrs: {
                          value: _vm.reducedCapacity,
                          type: "number",
                          min: "0",
                          outlined: "",
                          dense: "",
                          "error-messages": _vm.displayErrors.reduced_capacity,
                        },
                        on: { input: _vm.onReducedCapacityChange },
                      }),
                      _c(
                        "div",
                        { staticClass: "text-caption grey--text mt-2" },
                        [_vm._v(" lugares ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "4" } },
            [
              _c(
                "v-card",
                {
                  class: [
                    "capacity-card",
                    { "capacity-card--active": _vm.capacityMode === "CONV" },
                  ],
                  attrs: { outlined: "" },
                  on: {
                    click: function ($event) {
                      return _vm.selectMode("CONV")
                    },
                  },
                },
                [
                  _c(
                    "v-card-text",
                    { staticClass: "text-center pa-3" },
                    [
                      _c(
                        "v-radio-group",
                        {
                          staticClass: "mt-0 mb-2",
                          attrs: {
                            value: _vm.capacityMode,
                            "hide-details": "",
                          },
                          on: { change: _vm.selectMode },
                        },
                        [
                          _c("v-radio", {
                            staticClass: "justify-center",
                            attrs: { value: "CONV" },
                            scopedSlots: _vm._u([
                              {
                                key: "label",
                                fn: function () {
                                  return [
                                    _c(
                                      "span",
                                      { staticClass: "text-subtitle-2" },
                                      [_vm._v("Convencional")]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "active-slot mb-2" },
                        [
                          _c(
                            "v-chip",
                            {
                              class: {
                                "active-slot__chip--hidden":
                                  _vm.capacityMode !== "CONV",
                              },
                              attrs: { "x-small": "", color: "primary" },
                            },
                            [_vm._v(" Ativo ")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "capacity-desc text-caption grey--text mb-2",
                        },
                        [_vm._v(" Capacidade real padrão ")]
                      ),
                      _c("v-text-field", {
                        staticClass: "centered-input",
                        attrs: {
                          value: _vm.capacity,
                          type: "number",
                          min: "1",
                          outlined: "",
                          dense: "",
                          "error-messages": _vm.displayErrors.capacity,
                        },
                        on: { input: _vm.onCapacityChange },
                      }),
                      _c(
                        "div",
                        { staticClass: "text-caption grey--text mt-2" },
                        [_vm._v(" lugares ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "4" } },
            [
              _c(
                "v-card",
                {
                  class: [
                    "capacity-card",
                    { "capacity-card--active": _vm.capacityMode === "AMP" },
                  ],
                  attrs: { outlined: "" },
                  on: {
                    click: function ($event) {
                      return _vm.selectMode("AMP")
                    },
                  },
                },
                [
                  _c(
                    "v-card-text",
                    { staticClass: "text-center pa-3" },
                    [
                      _c(
                        "v-radio-group",
                        {
                          staticClass: "mt-0 mb-2",
                          attrs: {
                            value: _vm.capacityMode,
                            "hide-details": "",
                          },
                          on: { change: _vm.selectMode },
                        },
                        [
                          _c("v-radio", {
                            staticClass: "justify-center",
                            attrs: { value: "AMP" },
                            scopedSlots: _vm._u([
                              {
                                key: "label",
                                fn: function () {
                                  return [
                                    _c(
                                      "span",
                                      { staticClass: "text-subtitle-2" },
                                      [_vm._v("Ampliada")]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "active-slot mb-2" },
                        [
                          _c(
                            "v-chip",
                            {
                              class: {
                                "active-slot__chip--hidden":
                                  _vm.capacityMode !== "AMP",
                              },
                              attrs: { "x-small": "", color: "primary" },
                            },
                            [_vm._v(" Ativo ")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "capacity-desc text-caption grey--text mb-2",
                        },
                        [_vm._v(" Máximo de segurança ")]
                      ),
                      _c("v-text-field", {
                        staticClass: "centered-input",
                        attrs: {
                          value: _vm.extendedCapacity,
                          type: "number",
                          min: "0",
                          outlined: "",
                          dense: "",
                          "error-messages": _vm.displayErrors.extended_capacity,
                        },
                        on: {
                          input: _vm.onExtendedCapacityInput,
                          focus: function ($event) {
                            _vm.extendedFocused = true
                          },
                          blur: _vm.onExtendedCapacityBlur,
                        },
                      }),
                      _c(
                        "div",
                        { staticClass: "text-caption grey--text mt-2" },
                        [_vm._v(" lugares ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.showActiveCapacity
        ? _c(
            "v-row",
            { staticClass: "mt-2" },
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "v-alert",
                    { attrs: { type: "info", dense: "", text: "" } },
                    [
                      _c("strong", [_vm._v("Capacidade ativa:")]),
                      _vm._v(
                        " " +
                          _vm._s(_vm.activeCapacityValue) +
                          " lugares (" +
                          _vm._s(_vm.activeCapacityLabel) +
                          ") "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }